import React, { useState, useEffect } from 'react';
import $ from 'jquery';
type TypeAnswerProps = {
    text:string,
    delay:number,
    showButtonExpand?: any,
    showMoreButton?: any
};

const TypeAnswer = ({ text, delay, showButtonExpand, showMoreButton}: TypeAnswerProps) => {
    const [currentText, setCurrentText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const writeAnswer = (text: string, currentIndex: number, isWthShowMore = false) => {
        if (currentIndex < text?.length) {
            setCurrentText(text.substring(0, currentIndex));
            setCurrentIndex(prevIndex => prevIndex + 100 > text.length ? text.length - 1 : prevIndex + 100);
            if (isWthShowMore) {
                //@ts-ignore
                let totalHeight = $(".answer-content-wrap .answer-content")?.outerHeight(true) + $(".answer-content-wrap .answer-footer")?.outerHeight(true)
                //@ts-ignore
                if (totalHeight > 282 && !showMoreButton && !window.expandClick) {
                    showButtonExpand(totalHeight > 282);
                }
            }
        }
    }

    // Typing logic goes here
    useEffect(() => {
        if (!showMoreButton) {
            const timeoutWithShowMore = setTimeout(() => {
                writeAnswer(text, currentIndex, true);
            }, delay);
            return () => clearTimeout(timeoutWithShowMore);
        }
        const timeoutNoShowMore = setTimeout(() => {
            writeAnswer(text, currentIndex);
        }, delay);
        return () => clearTimeout(timeoutNoShowMore);
    }, [currentIndex, delay, text]);
    return <p>{currentText}</p>;
};

export default TypeAnswer;